type MenuIconProps = {
  colorFill?: string;
  width?: string;
  height?: string;
};

export const MenuIcon = ({
  colorFill = '#1B478A',
  width = '60px',
  height = '60px',
}: MenuIconProps) => (
  <svg fill="none" width={width} height={height} viewBox="0 0 32 32">
    <rect x="6" y="8" width="20" height="2" rx="1" fill={colorFill} />
    <rect x="6" y="14.998" width="20" height="2" rx="1" fill={colorFill} />
    <rect x="6" y="22.001" width="20" height="2" rx="1" fill={colorFill} />
  </svg>
);
